// src/services/apiVideoConfig.js
import axios from "axios";
import { BASE_URL } from "./constant";
const API_BASE = process.env.REACT_APP_API_BASE || BASE_URL;

//const API_BASE =  "https://www.yaofele.com";

//process.env.REACT_APP_API_BASE || "http://localhost:3001";

/**
 * ================================
 * RÉCUPÉRER la configuration d'une vidéo
 * ================================
 * Retourne NULL si non configurée
 */
export async function fetchVideoConfig(videoId) {
  try {
    const res = await axios.get(
      `${API_BASE}/api/video-schedules/${videoId}`
    );
    return res.data?.data || null;
  } catch (err) {
    console.warn("fetchVideoConfig failed:", err);
    return null;
  }
}

/**
 * =========================================
 * CRÉER ou METTRE À JOUR la configuration
 * (UPSERT)
 * =========================================
 */
export async function saveVideoConfig(payload) {
  /**
   * payload attendu :
   * {
   *   video_id: number,
   *   days_of_week: number[],
   *   full_day: boolean,
   *   start_time?: string,
   *   end_time?: string
   * }
   */
  try {
    const res = await axios.post(
      `${API_BASE}/api/video-schedules`,
      payload
    );
    return res.data;
  } catch (err) {
    console.error("saveVideoConfig failed:", err);
    throw err;
  }
}

/**
 * ================================
 * METTRE À JOUR une config existante
 * (optionnel si tu utilises POST uniquement)
 * ================================
 */
export async function updateVideoConfig(id, payload) {
  try {
    const res = await axios.put(
      `${API_BASE}/api/video-schedules/${id}`,
      payload
    );
    return res.data;
  } catch (err) {
    console.error("updateVideoConfig failed:", err);
    throw err;
  }
}

/**
 * ================================
 * SUPPRIMER la configuration d'une vidéo
 * ================================
 */
export async function deleteVideoConfig(id) {
  try {
    const res = await axios.delete(
      `${API_BASE}/api/video-schedules/${id}`
    );
    return res.data;
  } catch (err) {
    console.error("deleteVideoConfig failed:", err);
    throw err;
  }
}
